import { render, staticRenderFns } from "./onlineticket.vue?vue&type=template&id=65d9e68c&scoped=true"
import script from "./onlineticket.vue?vue&type=script&lang=js"
export * from "./onlineticket.vue?vue&type=script&lang=js"
import style0 from "./onlineticket.vue?vue&type=style&index=0&id=65d9e68c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d9e68c",
  null
  
)

export default component.exports